<template>
   <div class="result-card">
      <div class="title">{{ title }}</div>
      <info-item
         v-for="([label,value], index) in Object.entries(infos)"
         :key="`${index}`"
         :name="label"
         :value="value"
      />
   </div>
</template>

<script>
import InfoItem from '../../../molecules/Home/InfoItem';

export default {
   name: 'bat-result-scenario',
   components: {
      InfoItem,
   },
   props: {
      title: {
         type: String,
         required: true,
      },
      infos: {
         type: Object,
         required: true,
      }
   }
};
</script>

<style lang="scss" scoped>
.result-card {
   border-radius: 0.25em;
   width: 100%;
   background: white;
   margin: 0.5em;
   > .title {
      padding: 0.6em 1em;
      border-radius: 0.25em 0.25em 0 0;
      color: $font-color;
   }
}
</style>